import React, { Component } from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import * as mpp from 'vechain-contracts/prototype';

import { getNetType, atou } from '../services/utilities';
import { testNetPollContractAddress, mainNetPollContractAddress } from '../contractsData/pollContract';

import { ErrorMessage } from '../shared/layout'

import { upgradeMdl } from '../utils';

const styles = {
  sideMargin: {
    margin: '12px'
  },
  errorContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  errorComp: {
    padding: 8,
    width: '100%',
    height: 'unset',
    marginLeft: '24px',
    marginRight: '24px',
    marginBottom: '10px'
  },
  confirmationComp: {
    padding: 8,
    width: '100%',
    height: 'unset',
    marginLeft: '24px',
    marginRight: '24px',
    color: 'blue',
    border: 'solid blue 1px',
    boxShadow: '0 2px 2px 0 rgba(0,0,255,.14), 0 3px 1px -2px rgba(0,0,255,.2), 0 1px 5px 0 rgba(0,0,255,.12)',
  },
  infoP: { margin: '6px 0'}
}

export class LandingBase extends Component {

  state = {
    pollTokenAndId: '',
    pollTokenAndIdError: '',
    txId: '',
    txError: '',
    pollHash: '',
    pollHashError: '',
    pollAsJson: [],
    sponsoring: false,
    sponsorError: '',
    sponsored: false,
    net: null,
  }

  componentDidMount() {
    const txSearch = '?tx=';

    if (this.props && this.props.location && this.props.location.search && this.props.location.search.indexOf(txSearch) !== -1) {
      const pollTokenAndId = this.props.location.state ? this.props.location.state.tokenAndId : '';
      const net = this.props.location.state ? this.props.location.state.net : null;
      const txId = this.props.location.search.replace(txSearch, '');

      this.setState({ txId, pollTokenAndId, net });
    }

    upgradeMdl();
  }

  componentDidUpdate() {
    upgradeMdl();
  }

  render() {
    const txSearch = '?tx=';
    const { net } = this.state;

    return (
      <div className="mdl-cell mdl-cell--12-col mdl-cell--12-col-tablet mdl-grid">
        {
          this.props && this.props.location && this.props.location.search && this.props.location.search.indexOf(txSearch) !== -1 ?
            <div className="mdl-card mdl-shadow--2dp mdl-cell mdl-cell--12-col mdl-cell--12-col-tablet mdl-cell--12-col-desktop">
              <div className="mdl-card__title mdl-color--primary mdl-color-text--white">
                <h2 className="mdl-card__title-text">Transaction confirmation</h2>
              </div>
                <div className="poll-management-container">
                <p style={styles.infoP}><span style={{ fontSize: 16, color: '#ff4081', fontWeight: 'bold' }}>Congratulations</span>, your vote has been written in blockchain!</p>
                <p style={styles.infoP}>Transaction ID: <span style={{ fontSize: 16, color: '#ff4081', fontWeight: 'bold' }}>{this.state.txId}</span></p>
                <p style={styles.infoP}>You can now confirm your transaction validity or check the poll results below.</p>
                <p style={styles.infoP}>Just hit [Check results] button to get results directly from blockchain!</p>
              </div>
            </div>
          : null
        }

        <div className="mdl-card mdl-shadow--2dp mdl-cell mdl-cell--12-col mdl-cell--12-col-tablet mdl-cell--12-col-desktop">
          <div className="mdl-card__title mdl-color--primary mdl-color-text--white">
            <h2 className="mdl-card__title-text">Poll management</h2>
          </div>
          <div className="poll-management-container">
          <p style={styles.infoP}>Received voting token from poll creator? Insert it below and complete your vote or check the results!</p>
          <p style={styles.infoP}>Want to create poll yourself? Register account, go to My Polls, create poll and collect tokens that you can share with others</p>
            <div className={`mdl-textfield mdl-js-textfield mdl-textfield--floating-label ${this.state.pollTokenAndId ? 'is-dirty': ''}`} style={styles.sideMargin}>
              <input className="mdl-textfield__input" type="text" id="pollTokenAndId" onChange={(e) => this.updateInput(e, 'pollTokenAndId')} value={this.state.pollTokenAndId}></input>
              <label className="mdl-textfield__label" htmlFor="pollTokenAndId">Token</label>
            </div>
            <button className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent" style={styles.sideMargin} onClick={() => this.goToVoting(false)}>
              Vote
            </button>
            <button className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent" style={styles.sideMargin} onClick={() => this.goToVoting(true)}>
              Check results
            </button>
          </div>
          { this.state.pollTokenAndIdError ? <div style={styles.errorContainer}><ErrorMessage overrideStyles={styles.errorComp} message={this.state.pollTokenAndIdError} /></div> : null }
        </div>

        <div className="mdl-card mdl-shadow--2dp mdl-cell mdl-cell--12-col mdl-cell--12-col-tablet mdl-cell--12-col-desktop">
          <div className="mdl-card__title mdl-color--primary mdl-color-text--white">
            <h2 className="mdl-card__title-text">Validation panel</h2>
          </div>
          <div className="tx-validation-container">
          <p style={styles.infoP}>Voted already? Insert your transaction ID and verify your transaction on the blockchain!</p>
          <p style={styles.infoP}>You can also verify poll structure (questions and possible answers) by inserting poll hash taken from the blockchain.</p>
            <div className={`mdl-textfield mdl-js-textfield mdl-textfield--floating-label ${this.state.txId ? 'is-dirty': ''}`} style={styles.sideMargin}>
              <input className="mdl-textfield__input" type="text" id="txId" onChange={(e) => this.updateInput(e, 'txId')} value={this.state.txId}></input>
              <label className="mdl-textfield__label" htmlFor="txId">Transaction ID</label>
            </div>
            {
              window.connex ?
              <button className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent" style={styles.sideMargin} onClick={this.checkTx}>
                Check transaction
              </button>
              :
              <span>
                { !net || net === 'TEST' ?
                  <button className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent" style={styles.sideMargin} onClick={() => this.checkTx('testnet')}>
                    Check transaction [Testnet]
                  </button> : null
                }
                { !net || net === 'MAIN' ?
                  <button className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent" style={styles.sideMargin} onClick={() => this.checkTx('explore')}>
                    Check transaction [Mainnet]
                  </button> : null
                }
              </span>
            }

          </div>
          { this.state.txError ? <div style={styles.errorContainer}><ErrorMessage overrideStyles={styles.errorComp} message={this.state.txError} /></div> : null }

          <div className="poll-validation-container">
            <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label" style={styles.sideMargin}>
              <input className="mdl-textfield__input" type="text" id="pollHash" onChange={(e) => this.updateInput(e, 'pollHash')} value={this.state.pollHash}></input>
              <label className="mdl-textfield__label" htmlFor="pollHash">Poll hash</label>
            </div>
            <button className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent" style={styles.sideMargin} onClick={this.checkPoll}>
              Check poll validation
            </button>
          </div>
          { this.state.pollHashError ? <div style={styles.errorContainer}><ErrorMessage overrideStyles={styles.errorComp} message={this.state.pollHashError} /></div> : null }
          {
            !this.state.pollHashError && this.state.pollAsJson && this.state.pollAsJson.length ?
            <div>
              {
                this.state.pollAsJson.map(question => {
                  return (
                    <div style={{ width: '50%', margin: '10px auto', padding: 10, textAlign: 'left', boxShadow: '0px 1px 1px rgba(0,0,0,0.16), 0px 1px 1px rgba(0,0,0,0.16)', fontSize: 12, fontWeight: 'bold' }}>
                      <p className="question" style={{ marginBottom: 0 }}>{question.name}</p>
                      { question.answers.map(answer => <p style={{ marginBottom: 0, marginLeft: 32, fontSize: 12 }} className="answer">{answer}</p>) }
                    </div>
                  );
                })
              }
            </div>
            : null
          }
        </div>

        <div className="mdl-card mdl-shadow--2dp mdl-cell mdl-cell--12-col mdl-cell--12-col-tablet mdl-cell--12-col-desktop">
          <div className="mdl-card__title mdl-color--light-blue-600 mdl-color-text--white">
            <h2 className="mdl-card__title-text">Become a sponsor</h2>
          </div>
          <div className="poll-management-container">
          <p style={styles.infoP}>Thanks to Multi-Party Payment Protocol, you can safely add yourself as sponsor to Voting smart contract</p>
          <p style={styles.infoP}>Selected sponsors funds will be automatically spent on network costs during poll votings</p>
            <button className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent" style={styles.sideMargin} onClick={this.sponsor}>
              Sponsor
            </button>
          </div>
          { this.state.sponsorError ? <div style={styles.errorContainer}><ErrorMessage overrideStyles={styles.errorComp} message={this.state.sponsorError} /></div> : null }
          { this.state.sponsored ? <div style={styles.errorContainer}><ErrorMessage overrideStyles={styles.confirmationComp} message={`Thank you for sponsoring VoteChain! \n Your txID: ${this.state.sponsorTx}`} /></div> : null }
        </div>

      </div>
    );
  }

  sponsor = async () => {
    if (!window.connex) {
      window.location.href = 'https://env.vechain.org/r/#' + encodeURIComponent(window.location.href);
      return;
    }

    this.setState({ sponsoring: true, sponsorError: null })
    const net = await getNetType();

    const address = net === 'MAIN' ? mainNetPollContractAddress : testNetPollContractAddress;
    const clause = mpp.sponsor().asClause(address);
    const signingService = window.connex.vendor.sign('tx');

    signingService.request([clause])
      .then(response => {
        this.setState({ sponsoring: false, sponsored: true, sponsorTx: response.txid });
      })
      .catch(err => {
        console.error(err);
        this.setState({ sponsorError: err ? err.message : 'GENERIC_ERROR', sponsoring: false });
      })
  }


  updateInput = (event, stateName) => {
    this.setState({
      [stateName]: event.target.value,
    })
  }

  goToVoting = (readOnly = true) => {
    const page = readOnly ? 'details' : 'vote';
    const [ pollId, token ] = this.state.pollTokenAndId.split('_');
    const mapper = {
      'REDDIT': 'ISD5zM2yseUD7ui8wUY8',
      'VOTECHAIN': 'ISD5zM2yseUD7ui8wUY8',
      'WYKOP': 'edqg7SO10JzzwhywH0AF'
    }

    if (!pollId || !token) {
      this.setState({ pollTokenAndIdError: `Invalid poll token. Should be something like => DDbaPEdWIPwtiEERqURP_0diqS28kJE1pe7Zf0ToG` })
    } else {
      let id;
      if (token === 'DEMO') {
        id = readOnly ? mapper[pollId] || pollId : `${mapper[pollId] || pollId}_${token}`;
      } else {
        id = readOnly ? pollId : `${pollId}_${token}`
      }
      this.props.history.push(`/${page}/${id}`);
    }
  }

  checkTx = (address) => {
    const TX_LEN = 66;
    if (!this.state.txId || this.state.txId.length != TX_LEN) {
      this.setState({ txError: 'Invalid TX ID. Should be something like => 0x8fad5f9900f9a4a6e45370814de9705bde0b399d4c833619211e6fb8c469ce4d' })
    } else {
      this.setState({ pollTokenAndIdError: '', txError: '', pollHashError: '' });
      window.connex ?
      window.open(`https://insight.vecha.in/#/txs/${this.state.txId}`, '_blank') :
      window.open(`https://${address}.veforge.com/transactions/${this.state.txId}`, '_blank');
    }
  }

  checkPoll = () => {
    const encoded = atou(this.state.pollHash);
    try {
      const json = JSON.parse(encoded);
      this.setState({ pollAsJson: json.questions, pollHashError: '' });
    } catch(e) {
      this.setState({ pollHashError: 'Invalid poll hash'});
    }
  }

}

export const Landing = compose(withRouter)(LandingBase);
